import React from 'react'
import Buttom from 'react-bootstrap/Button'
import LoadingSpinner from '../loadingSpiner'


const LoadingButton = (props)=>{
    return(
        <Buttom
            style={{...props.style}} 
            className="loading-container"
            onClick={props.handleLogin}
            variant="success"
            disabled={props.disabled}>
            {!props.disabled? 
                <span style={{color: props.textStyles ? '#1D834F': ''}}>{props.text}</span> :
                <div style={{display: 'flex', justifyContent: 'center'}}>
                     <LoadingSpinner/>
                </div>
               
            }
        </Buttom>
    )
}

export default LoadingButton